import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useRemoveExternalAccount = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const removeExternalAccount = useCallback(
        async (user: UserType, accountId?: number) => {
            try {
                await services.api.call({
                    method: 'delete',
                    url: `/api/user-external-accounts/${accountId}`,
                });
                const updatedUser = {
                    ...user,
                    user_external_accounts: user?.user_external_accounts.filter(
                        (x) => x.id !== accountId
                    ),
                };
                // Publish event
                services.events.publish(events.user_updated, updatedUser);
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.user_updated]
    );

    return removeExternalAccount;
};
